import { render, staticRenderFns } from "./PendingAuditOrders.vue?vue&type=template&id=1dc4ac56"
import script from "./PendingAuditOrders.vue?vue&type=script&lang=js"
export * from "./PendingAuditOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports